const maxContainerWidth = '1100px';

export default {
  fullWidth: `
    width: 100%;
    max-width: ${maxContainerWidth};
    `,
  maxContainerWidth
};
